import "./Solutions.module.css";
import Header from "@/reusable_sections/Header";
import ArchitettureESicurezza from "./sections/ArchitettureESicurezza";
import LogisticaEDispositivi from "./sections/LogisticaEDispositivi";
import TechStackEcosystem from "./sections/TechStackEcosystem";
import PièDiPagina from "@/reusable_sections/Footer";
export default function SolutionsPage() {
  return <div>
      <Header />
      <ArchitettureESicurezza />
      <LogisticaEDispositivi />
      <TechStackEcosystem />
      <PièDiPagina />
    </div>;
}